// extracted by mini-css-extract-plugin
export default {"root":"IconSocialMediaTelegram_root__ds3Nr"};